import React from 'react';

const iconPath =
  'M12 24c6.625 0 12-5.375 12-12S18.625 0 12 0 0 5.375 0 12s5.375 12 12 ' +
  '12zm1.438-9.5h-2.891c-.297 0-.531-.172-.531-.39L9.75 4.405c0-.11.047-.218.156-.281A.' +
  '602.602 0 0 1 10.281 4h3.438c.14 0 .281.047.375.125.11.063.156.172.156.281l-.281 9.7' +
  '03c-.016.22-.25.391-.531.391zm.078 5.5h-3a.52.52 0 0 1-.516-.516v-2.968a.52.52 0 0 1' +
  ' .516-.516h3c.265 0 .484.234.484.516v2.968c0 .282-.219.516-.484.516z';

const WarningIconDisc = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path d={iconPath} fill="#FFF" fillRule="nonzero" />
  </svg>
);

export default WarningIconDisc;
